import { DetailsWithPaymentForm } from "components/details-form/details-with-payment-form";
import { SelectTime } from "components/selection-components/select-time/select-time";
import "config/i18n";
import { PreorderProvider } from "context/preorder-provider";
import BookingFlowLayout from "layout/booking-flow-layout";
import AvailabilityActivityBooking from "pages/availability/availability-activity-booking";
import MyBooking from "pages/booking-details/my-booking";
import BookingPreorderView from "pages/booking-preorder/booking-preorder-view";
import BookingWizard from "pages/booking-wizard";
import BookingRequestWizard from "components/booking-request/booking-request-wizard";
import { ErrorView } from "pages/error-view";
import PaymentConfirmation from "pages/payment-confirmation";
import { RouteObject } from "react-router-dom";
import { BookingProvider } from "store/store";
import { BookingRequestIntro } from "components/booking-request/booking-request-intro";

export enum Routes {
    BOOKING = "booking",
    ACTIVITY_BOOKING = "activity-booking",
    BOOKING_REQUEST = "booking-request",
    BOOKING_REQUEST_INTRO = "booking-request-intro",
    WIZARD = "",
    AVAILABILITY = "availability",
    FINALIZE = "finalize",
    PAYMENT_CONFIRMATION = "payment-confirmation",
    PREORDER = "preorder",
}

const routes: RouteObject[] = [
    {
        path: "/",
        errorElement: <ErrorView />,
        element: <BookingProvider />,
        children: [
            {
                path: "/booking/:system/:bookingId",
                element: <MyBooking />,
            },
            {
                path: `/booking/:system/${Routes.ACTIVITY_BOOKING}/:bookingId`,
                element: <MyBooking />,
            },
            {
                path: `/:system/:unitId/${Routes.PAYMENT_CONFIRMATION}`,
                element: <PaymentConfirmation />,
            },
            {
                path: `/:system/:unitId/${Routes.PAYMENT_CONFIRMATION}/:bookingId`,
                element: <PaymentConfirmation />,
            },
            {
                path: `/:system/:unitId/${Routes.ACTIVITY_BOOKING}/${Routes.PAYMENT_CONFIRMATION}/:bookingId`,
                element: <PaymentConfirmation />,
            },
            {
                element: <BookingFlowLayout />,
                children: [
                    {
                        path: "/:system/:unitId",
                        children: [
                            { index: true, element: <BookingWizard /> },
                            {
                                path: Routes.AVAILABILITY,
                                element: <SelectTime />,
                            },
                            {
                                path: Routes.PREORDER,
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <PreorderProvider>
                                                <BookingPreorderView />
                                            </PreorderProvider>
                                        ),
                                    },
                                    {
                                        path: ":bookingId",
                                        element: (
                                            <PreorderProvider>
                                                <BookingPreorderView />
                                            </PreorderProvider>
                                        ),
                                    },
                                ],
                            },
                            {
                                path: Routes.FINALIZE,
                                children: [
                                    { index: true, element: <DetailsWithPaymentForm /> },
                                    { path: ":bookingId", element: <DetailsWithPaymentForm /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: `/:system/:unitId/${Routes.ACTIVITY_BOOKING}`,
                        children: [
                            { index: true, element: <BookingWizard /> },
                            {
                                path: Routes.AVAILABILITY,
                                element: <AvailabilityActivityBooking />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                            { path: "finalize", element: <DetailsWithPaymentForm /> },
                            { path: "finalize/:bookingId", element: <DetailsWithPaymentForm /> },
                        ],
                    },
                    {
                        path: `/:system/:unitId/${Routes.BOOKING_REQUEST_INTRO}`,
                        children: [{ index: true, element: <BookingRequestIntro /> }],
                    },
                    {
                        path: `/:system/:unitId/${Routes.ACTIVITY_BOOKING}/${Routes.BOOKING_REQUEST_INTRO}`,
                        children: [{ index: true, element: <BookingRequestIntro /> }],
                    },
                    {
                        path: `/:system/:unitId/${Routes.ACTIVITY_BOOKING}/${Routes.BOOKING_REQUEST}`,
                        children: [
                            { index: true, element: <BookingRequestWizard /> },
                            {
                                path: Routes.AVAILABILITY,
                                element: <AvailabilityActivityBooking />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                            {
                                path: Routes.FINALIZE,
                                element: <DetailsWithPaymentForm />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                        ],
                    },
                    {
                        path: `/:system/:unitId/${Routes.BOOKING_REQUEST}`,
                        children: [
                            { index: true, element: <BookingRequestWizard /> },
                            {
                                path: Routes.AVAILABILITY,
                                element: <SelectTime />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                            {
                                path: Routes.FINALIZE,
                                element: <DetailsWithPaymentForm />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

export default routes;
